module.exports = __webpack_public_path__ + "static/media/design_icon.7aab0dec.svg";